<template>
<v-container>
  <v-card>
    <v-card-text>
      <v-text-field
                v-model="searchChamada"
                append-icon="mdi-magnify"
                label="Filtrar chamadas"
                single-line
                hide-details
                
      ></v-text-field>
      <v-data-table
        dense
        :search="searchChamada"
        :items="chamadas"
        :headers="headersChamadas"
        :loading="isLoadingChamadas"
      >
        <template v-slot:[`item.actions`]="{ item }">
          <botao-email-com-confirmacao
            @confirm="enviarEmailsChamada(item)"
            ctexto="Enviar email a todos os candidatos desta chamada?"
          >
          </botao-email-com-confirmacao>
        </template>
      </v-data-table>
      <v-card-actions>
        <v-btn @click="adicionarChamada"
        >Adicionar <v-icon color="primary"> mdi-plus </v-icon></v-btn
        >
      </v-card-actions>
    </v-card-text>
  </v-card>
  <v-row justify="center">
      <v-dialog v-model="dlgChamada" persistent max-width="600px">
        <v-card>
          <v-card-title>Incluir Chamada</v-card-title>
          <form>
            <v-card-text>
              <v-text-field
                v-model="chamada.titulo"
                label="Título"
                required
              ></v-text-field>
              <v-text-field
                v-model="chamada.sigla"
                label="Sigla"
                required
              ></v-text-field>
              <v-text-field
                v-model="chamada.ordemExibicao"
                type="number"
                label="Ordem de Exibição (1 - Sisu, 2 - PSS, 3 - PIN, 4 - Outras)"                                    
                required
              ></v-text-field>
              <v-datetime-picker dateFormat="dd/MM/yyyy" :datePickerProps="{'locale':'pt-BR'}" label="Início das Inscrições" v-model="chamada.inscricaoInicio" locale="pt_BR"> </v-datetime-picker>
              <v-datetime-picker dateFormat="dd/MM/yyyy" label="Fim das Inscrições" v-model="chamada.inscricaoFim" locale="pt_BR"> </v-datetime-picker>
              <v-select :items="processosSeletivos" v-model="chamada.idProcessoSeletivo" required item-value="id" item-text="descricao">
                <template #label>
                  Processo Seletivo
                  <span class="red--text"><strong> *</strong></span>
                </template>
              </v-select>
              <v-file-input
                accept="csv"
                label="Arquivo de candidatos"
                v-model="chamada.arquivo"
              ></v-file-input>
            </v-card-text>
            <v-card-actions>
              <v-btn class="mr-4" @click="salvarChamada"> Salvar </v-btn>
              <v-btn @click="cancelarInclusao"> Cancelar </v-btn>
            </v-card-actions>
          </form>
        </v-card>
      </v-dialog>
    </v-row>
  </v-container>
</template>

<script>
import BotaoEmailComConfirmacao from '@/components/BotaoEmailComConfirmacao.vue';
import Chamada from "@/models/chamada";
import * as ChamadaService from "@/services/chamada.service";
import { mapGetters } from 'vuex';

export default {
  components: { BotaoEmailComConfirmacao},
  data() {
    return {
      searchChamada: "",
      dlgChamada: false,
      isLoadingChamadas: false,
      chamada: {},
      headersChamadas: [
        {
          text: "Sigla",
          align: "start",
          sortable: false,
          value: "sigla",
        },
        {
          text: "Título",
          align: "start",
          sortable: false,
          value: "titulo",
        },
        {
          text: "Processo Seletivo",
          align: "start",
          sortable: false,
          value: "processoSeletivo.descricao",
        },
        {
          text: "Início",
          align: "start",
          sortable: false,
          value: "inscricaoInicio",
          width: "",
        },
        {
          text: "Fim",
          align: "start",
          sortable: false,
          value: "inscricaoFim",
          width: "",
        },
        { text: "Ações", value: "actions", sortable: false, align: "center" },
      ],
    }
  },
  mounted() {
    
  },
  methods : {
    salvarChamada(){
      this.$nprogress.start();
      this.$store.dispatch('chamadas/create', this.chamada)
        .then(() => {
          this.$msg.success("Chamada salva com sucesso!");
          this.dlgChamada = false;
        })
        .catch(() => {
          this.$msg.error('Erro ao gravar chamada!');
        })
        .finally(() => this.$nprogress.done());
    },    
    cancelarInclusao() {
      this.chamada = new Chamada();
      this.dlgChamada = false;
    },
    enviarEmailsChamada(item){
      this.$nprogress.start();
      ChamadaService.enviarEmails(item)
        .then((res) => {
          this.$msg.success("Emails Enviados: " + res.data);
        })
        .finally(() => this.$nprogress.done());
    },
    adicionarChamada() {
      this.dlgChamada = true;
    },
  },
  computed: {
    ...mapGetters({
      'chamadas':'chamadas/list',
      'processosSeletivos': 'processosSeletivos/list'
    }),
  }
};
</script>